import app_setting_zendure from '@devices/settings/common_settings/app_setting_zendure';
import settings_zendure from '@devices/settings/device_settings/settings_zendure';

export default {
	name: 'Shendure',
	friendly_name: 'Zendure SolarFlow',
	family: 'pv',
	isPM: true,
	reset_from_input: false,
	modes: {
		pv: {
			availableViews: ['basic', 'advanced'],
			channels: 1,
			min_charge_limits: [5, 50],
			max_charge_limits: [70, 100],
			notifications: ['offline', 'device_problem'],
			settings: [
				app_setting_zendure,
				{
					title: 'settings',
					components: [
						...settings_zendure.components,
						{
							title: 'device_information',
							component: 'device_information',
						},
					],
				},
			],
		},
	},
};
